import axios from "axios";

export const GetFilesList = async (): Promise<{ data: []; status: number }> => {
  const { data, status } = await axios.get('https://dmitryplus.github.io/otus_react_dz/files-list.json');

  if (status !== 200) {
    throw new Error();
  }

  return { data, status };
};
